import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-white pt-4 pb-8 px-4 md:px-8 text-center" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <p className="text-[#16a34a] font-bold tracking-widest uppercase mb-2 text-sm md:text-base bg-green-50 inline-block px-4 py-1 rounded-full mx-auto" data-id="element-74">
          PARA MAESTRAS DE PRIMARIA
        </p>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-4 max-w-3xl mx-auto" data-id="element-75">
          Resolvé todo tu año escolar en un solo lugar y olvidate de planificar
          desde cero con el{' '}
          <span className="text-[#16a34a]" data-id="element-76">kit completo primaria lista</span>
        </h1>

        <div className="mb-4 flex justify-center" data-id="element-77">
          <img src="https://cdn.magicpatterns.com/uploads/jzTGw72haaEs4jQkd7z3oJ/mockups_primaria_.png" alt="Kit Completo Primaria Lista" className="w-full max-w-2xl cursor-pointer hover:opacity-95 transition-opacity" onClick={scrollToPricing} data-id="element-78" />
        </div>

        <h2 className="text-xl md:text-2xl text-gray-700 font-medium mb-6 max-w-3xl mx-auto" data-id="element-79">
          Sistema completo de planificaciones, actividades y recursos listos
          para usar en primaria. Todas las materias. Todo el año. Resuelto.
        </h2>

        <div className="flex flex-col items-center gap-3" data-id="element-80">
          <Button fullWidth pulse className="text-xl md:text-2xl py-5 max-w-md w-full" onClick={scrollToPricing} data-id="element-81">
            👉 SÍ, QUIERO ACCESO INMEDIATO
          </Button>

          <div className="flex flex-wrap justify-center gap-3 text-xs md:text-sm text-gray-500 font-medium mt-1" data-id="element-82">
            <span className="flex items-center" data-id="element-83">🔒 Pago seguro</span>
            <span className="hidden md:inline" data-id="element-84">•</span>
            <span className="flex items-center" data-id="element-85">⚡ Descarga inmediata</span>
            <span className="hidden md:inline" data-id="element-86">•</span>
            <span className="flex items-center" data-id="element-87">🛡️ Garantía 7 días</span>
            <span className="hidden md:inline" data-id="element-88">•</span>
            <span className="flex items-center" data-id="element-89">♾️ Acceso de por vida</span>
          </div>
        </div>
      </div>
    </section>;
}